var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2217 101.312H49.6799V104.854H53.2217V101.312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1382 101.312H42.5964V104.854H46.1382V101.312Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9451 94.214H67.4033V97.7557H70.9451V94.214Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0288 90.6721H70.9453V94.2139H78.0288V90.6721Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8728 90.6721H21.3311V94.2139H24.8728V90.6721Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1955 87.1306H88.6538V90.6723H92.1955V87.1306Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1382 87.1304V83.5886H42.5964V80.0469H39.0547V87.1304H42.5964V90.6721H53.2217V87.1304H46.1382Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.331 87.1306H17.7893V90.6723H21.331V87.1306Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2478 76.5053H10.7061V80.0471H14.2478V76.5053Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3201 72.9634H56.7783V76.5052H60.3201V72.9634Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7056 72.9634H7.16382V76.5052H10.7056V72.9634Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7634 69.4216H53.2217V72.9633H56.7634V69.4216Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2217 65.88H42.5964V69.4218H53.2217V65.88Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3313 69.4216V65.8799H17.7895V62.3233H14.2478V58.7815H10.7061V65.8799H14.2478V69.4216H21.3313Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4297 48.1563H24.8879V51.698H28.4297V48.1563Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 44.6147H14.2478V48.1565H24.873V44.6147Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.836 33.9895H99.294V26.906H95.7523V23.3643H92.1957V19.8225H88.6539V16.2808H85.1122V12.739H78.0287V9.19729H70.9452V5.65555H39.0546V9.19729H31.9712V12.739H24.8877V16.2808H21.3459V19.8225H24.8877V23.3643H21.3459V26.906H17.7893V33.9895H24.8728V30.4477H28.4145V33.9895H24.8728V37.5312H21.331V41.073H24.8728V44.6147H28.4145V48.1565H31.9563V51.6982H28.4145V55.2399H31.9563V69.4069H28.4145V72.9487H21.331V76.4904H28.4145V83.5739H31.9563V87.1156H35.498V76.4904H39.0398V72.9487H42.5815V69.4069H39.0398V65.8652H42.5815V62.3234H53.2067V65.8652H56.7782V69.4069H60.32V72.9487H67.4035V80.0321H60.32V83.5739H63.8617V87.1156H81.5704V83.5739H85.1122V80.0321H88.6539V72.9487H81.5704V65.8652H88.6539V72.9487H92.1957V69.4069H99.2791V72.9487H95.7374V76.4904H92.1957V87.1156H95.7374V83.5739H99.2791V76.4904H102.821V69.4069H106.363V41.073H102.821V33.9895H102.836ZM42.5964 37.5312H35.5129V30.4477H42.5964V37.5312ZM78.0287 19.8076V26.906H70.9452V23.3643H63.8617V16.2808H74.4869V19.8225H78.0287V19.8076ZM70.9452 33.9895H67.4035V30.4477H70.9452V33.9895H74.4869V41.073H70.9452V33.9895ZM88.6539 37.5312V44.6147H81.5704V41.073H78.0287V33.9895H85.1122V37.5312H88.6539ZM88.6539 26.906H81.5704V23.3643H88.6539V26.906ZM46.1381 12.7242V16.2659H49.6799V19.8076H46.1381V16.2659H39.0546V19.8076H35.5129V16.2659H39.0546V12.7242H46.1381ZM28.4294 23.3494H31.9712V26.906H28.4294V23.3494ZM28.4294 37.5312H31.9712V41.073H28.4294V37.5312ZM49.6799 58.7817V51.6982H60.3051V41.073H49.6799V44.6147H46.1381V51.6982H42.5964V41.073H46.1381V37.5312H49.6799V33.9895H60.3051V37.5312H63.8468V51.6982H60.3051V55.2399H56.7782V58.7817H49.6799ZM74.4869 83.5888V80.047H78.0287V83.5888H74.4869ZM78.0287 69.4218H70.9452V62.3234H63.8617V55.2399H70.9452V62.3234H78.0287V69.4218ZM95.7374 65.88V62.3234H99.2791V65.8652H95.7374V65.88Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7056 33.9894H7.16382V37.5312H10.7056V33.9894Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2478 26.906H10.7061V30.4478H14.2478V26.906Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7895 23.3494H14.2478V26.8911H17.7895V23.3494Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.331 19.8075H17.7893V23.3493H21.331V19.8075Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7375 87.1306H92.1958V90.6723H95.7375V87.1306Z",
    fill: "#0E151D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6539 87.1305H92.1956V76.5053H95.7374V72.9636H99.2791V69.4218H92.1956V72.9636H88.6539V80.0471H85.1121V83.5888H81.5704V87.1305H63.8617V83.5888H60.3199V80.0471H67.4034V72.9636H60.3199V76.5053H56.7782V72.9636H53.2365V69.4218H42.6112V72.9636H39.0695V76.5053H35.5278V87.1305H31.986V83.5888H28.4443V76.5053H21.3608V72.9636H28.4443V69.4218H31.986V55.2549H28.4443V51.7131H24.9025V48.1714H14.2475V44.6147H24.8728V41.073H21.331V37.5313H24.8728V33.9895H17.7893V26.906H14.2475V30.4478H10.7058V26.906H7.16405V33.9895H10.7058V37.5313H7.16405V33.9895H3.62231V41.073H0.0805664V72.9636H3.62231V80.0471H7.16405V87.1305H10.7058V90.6723H14.2475V94.214H17.7893V97.7558H21.331V101.312H28.4145V104.854H35.498V108.396H70.9303V104.854H78.0138V101.312H85.0973V97.7707H88.639V94.2289H92.1956V90.6872H88.6539V87.1305ZM78.0287 90.6723V94.214H70.9452V97.7558H67.4034V94.214H70.9452V90.6723H78.0287ZM39.0546 80.0471H42.5964V83.5888H46.1381V87.1305H53.2216V90.6723H42.5964V87.1305H39.0546V80.0471ZM14.2475 69.4218V65.8801H10.7058V58.7966H14.2475V62.3235H17.7893V65.8652H21.331V69.4069H14.2475V69.4218ZM7.16405 76.5053V72.9636H10.7058V76.5053H14.2475V80.0471H10.7058V76.5053H7.16405ZM17.7893 90.6723V87.1305H21.331V90.6723H24.8728V94.214H21.331V90.6723H17.7893ZM42.5964 104.854V101.312H46.1381V104.854H42.5964ZM49.6798 104.854V101.312H53.2216V104.854H49.6798Z",
    fill: "#0E151D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2793 83.5887H95.7375V87.1305H99.2793V83.5887Z",
    fill: "#0E151D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0288 80.0469H74.4871V83.5886H78.0288V80.0469Z",
    fill: "#0E151D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.836 76.5053H99.2939V83.5888H102.836V76.5053Z",
    fill: "#0E151D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.378 69.4216H102.836V76.5051H106.378V69.4216Z",
    fill: "#0E151D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3201 69.4216H56.7783V72.9633H60.3201V69.4216Z",
    fill: "#0E151D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6538 65.88H81.5703V72.9635H88.6538V65.88Z",
    fill: "#0E151D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7634 65.88H53.2217V69.4218H56.7634V65.88Z",
    fill: "#0E151D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5964 65.88H39.0547V69.4218H42.5964V65.88Z",
    fill: "#0E151D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2793 62.3234H95.7375V65.8651H99.2793V62.3234Z",
    fill: "#0E151D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0288 62.3234H70.9453V69.4068H78.0288V62.3234Z",
    fill: "#0E151D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2217 62.3234H42.5964V65.8651H53.2217V62.3234Z",
    fill: "#0E151D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9453 55.24H63.8618V62.3234H70.9453V55.24Z",
    fill: "#0E151D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6799 51.6981V58.7816H56.7783V55.2399H60.32V51.6981H49.6799Z",
    fill: "#0E151D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8618 37.5312H60.32V33.9894H49.6799V37.5312H46.1382V41.0729H42.5964V51.6981H46.1382V44.6147H49.6799V41.0729H60.32V51.6981H63.8618V37.5312Z",
    fill: "#0E151D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9709 48.1563H28.4292V51.698H31.9709V48.1563Z",
    fill: "#0E151D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4297 44.6147H24.8879V48.1565H28.4297V44.6147Z",
    fill: "#0E151D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.919 41.0729H106.378V69.4217H109.919V41.0729Z",
    fill: "#0E151D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M106.378 33.9894H102.836V41.0729H106.378V33.9894Z",
    fill: "#0E151D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4871 33.9894H70.9453V41.0729H74.4871V33.9894Z",
    fill: "#0E151D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9709 37.531H28.4292V41.0728H31.9709V37.531Z",
    fill: "#0E151D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1121 33.9894H78.0286V41.0729H81.5703V44.6147H88.6538V37.5312H85.1121V33.9894Z",
    fill: "#0E151D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5964 30.4476H35.5129V37.5311H42.5964V30.4476Z",
    fill: "#0E151D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M102.836 26.906H99.2939V33.9895H102.836V26.906Z",
    fill: "#0E151D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9451 30.4476H67.4033V33.9893H70.9451V30.4476Z",
    fill: "#0E151D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4297 30.4476H24.8879V33.9893H28.4297V30.4476Z",
    fill: "#0E151D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2793 23.3494H95.7375V26.8911H99.2793V23.3494Z",
    fill: "#0E151D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6538 23.3494H81.5703V26.8911H88.6538V23.3494Z",
    fill: "#0E151D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9709 23.3494H28.4292V26.8911H31.9709V23.3494Z",
    fill: "#0E151D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.331 23.3494H17.7893V26.8911H21.331V23.3494Z",
    fill: "#0E151D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2478 23.3494H10.7061V26.8911H14.2478V23.3494Z",
    fill: "#0E151D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7375 19.8075H92.1958V23.3493H95.7375V19.8075Z",
    fill: "#0E151D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9453 23.3494V26.9061H78.0288V19.8077H74.487V16.266H63.8618V23.3494H70.9453Z",
    fill: "#0E151D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8728 19.8075H21.3311V23.3493H24.8728V19.8075Z",
    fill: "#0E151D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7895 19.8075H14.2478V23.3493H17.7895V19.8075Z",
    fill: "#0E151D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1955 16.266H88.6538V19.8077H92.1955V16.266Z",
    fill: "#0E151D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6797 16.266H46.1379V19.8077H49.6797V16.266Z",
    fill: "#0E151D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0547 16.266H35.5129V19.8077H39.0547V16.266Z",
    fill: "#0E151D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M21.331 16.266H17.7893V19.8077H21.331V16.266Z",
    fill: "#0E151D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6538 12.7241H85.1121V16.2659H88.6538V12.7241Z",
    fill: "#0E151D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1382 12.7241H39.0547V16.2659H46.1382V12.7241Z",
    fill: "#0E151D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8728 12.7241H21.3311V16.2659H24.8728V12.7241Z",
    fill: "#0E151D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1121 9.18228H78.0286V12.724H85.1121V9.18228Z",
    fill: "#0E151D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9714 9.18228H24.8879V12.724H31.9714V9.18228Z",
    fill: "#0E151D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0288 5.64072H70.9453V9.18246H78.0288V5.64072Z",
    fill: "#0E151D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0547 5.64072H31.9712V9.18246H39.0547V5.64072Z",
    fill: "#0E151D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9453 2.09888H39.0547V5.64062H70.9453V2.09888Z",
    fill: "#0E151D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlan);
export default __webpack_public_path__ + "static/media/basicPlan.f1667ecca466645e003a0d2279ab7027.svg";
export { ForwardRef as ReactComponent };